import type { ExperimentConfig } from '../@types'

// Single variant — the legacy `EmailFormExperiment.vue` / `NameForm.vue` /
// `PlanActivity.vue` screens are now rendered as DS-based UINode trees
// directly inside `ob-female-tai-chi-walking-pr-refactoring-v2`. No need
// for a parallel `*-ds` funnel: the control config IS the DS one.
const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-pr': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_refactor_result_complete~1
			funnel: {
				id: 'ob-female-tai-chi-walking-pr-refactoring-v2',
				locale: ['en'],
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_refactor_result_complete~1
			funnel: {
				id: 'ob-female-tai-chi-walking-v2-al-refactoring',
				locale: ['en'],
			},
		},
	},
]

export default config
